module.exports = __webpack_public_path__ + "img/1485168663.52a21695.jpg";